import React from 'react'
import './index.css'
import { Link } from 'react-router-dom'
import { APP_VERSION } from '../../../../configTools/version'

// This file is duplicated verbatim under layout/{admin,labadmin,doctor}/leftbar/watermark.
// Keep all three identical - change one, copy it to the other two.
const Index = () => {
  return (
    <div className='panel_watermark_wrapper'>
        <Link to={'https://www.nvisiondental.com'}>
            <div className='panel_watermark_contaier'>
                <p>powered by</p>
                <h5>N-Vision Dental</h5>
            </div>
        </Link>
        {/* Outside the Link, or clicking the version would navigate off to the website. */}
        <p className='panel_watermark_version'>v{APP_VERSION}</p>
    </div>
  )
}

export default Index
